export default ({getState,dispatch}) => (next) => (action) =>{
   console.log(`Action : ${action.type} ===> `, action);

   next(action);
}





// WEBPACK FOOTER //
// ./src/middlewares/log-middleware.js